import type {TrustStatus} from '@sollapay/enums';

/** A status group is folded per firm, so the same status can be open in one firm and folded in another. */
export const getGuestStatusGroupKey = (firmId: string, status: TrustStatus) =>
  `${firmId}:${status}`;
